var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { priceUtils } from '@utils';
import { Popup, Quantity, createPriceHtml, createAddToCartButton, setSlider, createCircle, } from '@vape-shop/blocks';
import { cartApi } from './view/cartApi';
import { SELECTORS } from './view/config';
import { EventBus } from './view/EventBus';
var button = document.querySelector('.wp-block-vape-shop-mini-cart');
var miniCartElement = document.querySelector('.mini-cart');
var progressBar = null;
var CHECKOUT_CART_REVISION_KEY = 'elfbarpods_checkout_cart_revision_v1';
var CHECKOUT_CART_CHANGED_EVENT = 'elfbarpods:cart-changed';
/**
 * Tell an already-open checkout that its server-backed totals are stale.
 *
 * Only an opaque revision is persisted: no cart, coupon, customer, or payment
 * data is written to browser storage. The DOM event covers this tab and the
 * storage event covers other tabs without polling.
 */
function broadcastCheckoutCartChange(reason) {
    var revision = "".concat(Date.now(), "-").concat(Math.random().toString(36).slice(2));
    window.dispatchEvent(new CustomEvent(CHECKOUT_CART_CHANGED_EVENT, {
        detail: { reason: reason, revision: revision },
    }));
    try {
        window.localStorage.setItem(CHECKOUT_CART_REVISION_KEY, revision);
    }
    catch (_error) {
        // Storage can be unavailable in strict privacy modes. Same-tab syncing
        // still works through the DOM event, and normal navigation remains intact.
    }
}
if (document.querySelector('.mini-cart__footer-counter')) {
    progressBar = {
        minAmontBar: document.querySelector('.mini-cart__counter-progress-input.to-min-amount'),
        freeShippingBar: document.querySelector('.mini-cart__counter-progress-input.to-free-shipping'),
        remainingElement: document.querySelector('.mini-cart__counter-value'),
        textElement: document.querySelector('.mini-cart__counter-label'),
        giftBar: document.querySelector(SELECTORS.MINI_CART_PROGRESS_GIFT_BAR),
    };
}
var CartItemQuantity = /** @class */ (function (_super) {
    __extends(CartItemQuantity, _super);
    function CartItemQuantity(data) {
        var _this = _super.call(this, {
            container: data.container,
            selectors: {
                decrease: data.selectors.decrease,
                increase: data.selectors.increase,
                input: data.selectors.input,
            },
        }) || this;
        _this.itemKey = data.itemKey;
        _this.setEventListener();
        return _this;
    }
    CartItemQuantity.prototype.increase = function () {
        _super.prototype.increase.call(this);
        this.updateCartItemQuantity();
    };
    CartItemQuantity.prototype.updateItemKey = function (itemKey) {
        this.itemKey = itemKey;
    };
    CartItemQuantity.prototype.decrease = function () {
        _super.prototype.decrease.call(this);
        this.updateCartItemQuantity();
        if (this.getValue() == 0) {
            EventBus.emit('removeItem', { itemKey: this.itemKey });
        }
    };
    CartItemQuantity.prototype.setQuantity = function (value) {
        this.input.value = value.toString();
    };
    CartItemQuantity.prototype.updateCartItemQuantity = function () {
        return __awaiter(this, void 0, void 0, function () {
            var response, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, cartApi.updateItemQuantity(this.itemKey, this.getValue())];
                    case 1:
                        response = _a.sent();
                        if (response.data.success) {
                            broadcastCheckoutCartChange('quantity');
                            EventBus.emit('updateCartItemQuantity', response.data.data);
                        }
                        else {
                            console.error('Failed to add product to cart:', response.data.data);
                        }
                        return [3 /*break*/, 3];
                    case 2:
                        error_1 = _a.sent();
                        console.error('Error adding product to cart:', error_1);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    return CartItemQuantity;
}(Quantity));
var MiniCart = /** @class */ (function (_super) {
    __extends(MiniCart, _super);
    function MiniCart(data) {
        var _a, _b, _c;
        var _this = _super.call(this, {
            popupElement: data.popupElement,
            closeButtonClass: data.closeButtonClass,
        }) || this;
        _this.coinRequestPending = false;
        _this.cartItems = new Map();
        _this.totalPriceElement = data.totalPriceElement;
        _this.cartListElement = data.cartListElement;
        _this.counterElement = data.counterElement;
        _this.checkoutButton = data.checkoutButton;
        _this.shipingElement = data.shipingElement;
        _this.progressBar = data.progressBar
            ? __assign(__assign({}, data.progressBar), { minAmount: Number((_a = data.progressBar.minAmontBar.querySelector('input')) === null || _a === void 0 ? void 0 : _a.max), freeAmount: Number((_b = data.progressBar.freeShippingBar.querySelector('input')) === null || _b === void 0 ? void 0 : _b.max), giftAmount: data.progressBar.giftBar
                    ? Number((_c = data.progressBar.giftBar.querySelector('input')) === null || _c === void 0 ? void 0 : _c.max)
                    : null }) : null;
        _this.init(data.cartItems);
        return _this;
    }
    MiniCart.prototype.init = function (cartItemElements) {
        var _this = this;
        var _a, _b;
        var crossSells = this.popupElement.querySelector('.mini-cart__cross-sells');
        this.crossSellsContainer = crossSells.querySelector('.mini-cart__cross-sells__wrapper');
        this.noticesContainer = this.popupElement.querySelector('.mini-cart__notices');
        this.couponBlock = this.popupElement.querySelector('.mini-cart__coupon');
        this.couponForm = this.couponBlock.querySelector('.mini-cart__coupon-form');
        this.coinContainer = this.popupElement.querySelector(SELECTORS.MINI_CART_COIN_CONTAINER);
        this.coinHandler = (_a = this.coinContainer) === null || _a === void 0 ? void 0 : _a.querySelector(SELECTORS.MINI_CART_COIN_CHECKBOX);
        this.coinTooltip = (_b = this.coinContainer) === null || _b === void 0 ? void 0 : _b.querySelector('.mini-cart__coin-tooltip');
        this.couponTooltip = this.couponBlock.querySelector('.mini-cart__coupon-tooltip');
        this.ensureDiscountRows();
        this.syncRewardUi();
        this.setEventListeners();
        if (cartItemElements.length) {
            cartItemElements.forEach(function (item) {
                var itemKey = item.getAttribute('data-key');
                var cartItem = {
                    element: item,
                    itemKey: itemKey,
                    quantity: new CartItemQuantity({
                        container: item.querySelector('.mini-cart__item-quantity'),
                        selectors: {
                            decrease: '.mini-cart__item-quantity-button_decrease',
                            increase: '.mini-cart__item-quantity-button_increase',
                            input: '.mini-cart__item-quantity-input',
                        },
                        itemKey: itemKey,
                    }),
                };
                _this.cartItems.set(itemKey, cartItem);
            });
            this.cartListElement.classList.remove('suspend');
        }
        else if (document.cookie.includes('woocommerce_items_in_cart') ||
            document.cookie.includes('woocommerce_cart_hash')) {
            this.getCart();
        }
        else {
            this.cartListElement.classList.add('empty');
            this.cartListElement.classList.remove('suspend');
        }
        setSlider({
            slider: crossSells,
            wrapper: this.crossSellsContainer,
            offset: 264,
            className: 'mini-cart__cross-sells',
        });
    };
    MiniCart.prototype.setEventListeners = function () {
        var _this = this;
        var _a, _b, _c, _d;
        _super.prototype.setEventListeners.call(this);
        EventBus.on('updateTotal', function (event) {
            _this.updateCartTotal(event.detail);
        });
        EventBus.on('updateCartItemQuantity', function (_a) {
            var detail = _a.detail;
            _this.updateCartItemQuantity(detail);
        });
        EventBus.on('removeItem', function (event) {
            _this.removeItem(event.detail.itemKey);
        });
        var couponOpener = this.couponBlock.querySelector('.mini-cart__coupon-opener');
        var activateCouponOpener = function () {
            var _a;
            if ((_a = _this.coinContainer) === null || _a === void 0 ? void 0 : _a.classList.contains('active')) {
                _this.toggleRewardTooltip(_this.couponTooltip);
                return;
            }
            _this.closeRewardTooltips();
            _this.couponBlock.classList.add('open');
        };
        couponOpener === null || couponOpener === void 0 ? void 0 : couponOpener.addEventListener('click', activateCouponOpener);
        couponOpener === null || couponOpener === void 0 ? void 0 : couponOpener.addEventListener('keydown', function (event) {
            if (event.key !== 'Enter' && event.key !== ' ')
                return;
            event.preventDefault();
            activateCouponOpener();
        });
        this.couponForm.addEventListener('submit', function (event) {
            event.preventDefault();
            _this.applyCoupon();
        });
        EventBus.on('updateMiniCart', function (event) {
            _this.updateCart(event.detail);
            broadcastCheckoutCartChange('cart');
        });
        EventBus.on('openMiniCart', function () {
            _this.open();
        });
        (_a = this.couponBlock.querySelectorAll('.mini-cart__coupon-applied-remove')) === null || _a === void 0 ? void 0 : _a.forEach(function (button) {
            button.addEventListener('click', function (event) {
                event.preventDefault();
                var code = button.getAttribute('data-coupon-code');
                _this.removeCoupon(code);
                button.classList.add('loading');
            });
        });
        (_b = this.coinHandler) === null || _b === void 0 ? void 0 : _b.addEventListener('change', function (event) {
            var _a;
            var input = event.target;
            if (_this.coinRequestPending) {
                input.checked = !!((_a = _this.coinContainer) === null || _a === void 0 ? void 0 : _a.classList.contains('active'));
                return;
            }
            void _this.toggleCoin(input.checked);
        });
        (_d = (_c = this.coinContainer) === null || _c === void 0 ? void 0 : _c.querySelector('.mini-cart__coin-info')) === null || _d === void 0 ? void 0 : _d.addEventListener('click', function (event) {
            event.preventDefault();
            event.stopPropagation();
            _this.toggleRewardTooltip(_this.coinTooltip);
        });
        document.addEventListener('click', function (event) {
            var _a;
            var target = event.target;
            if (!((_a = _this.coinContainer) === null || _a === void 0 ? void 0 : _a.contains(target)) && !_this.couponBlock.contains(target)) {
                _this.closeRewardTooltips();
            }
        });
    };
    MiniCart.prototype.ensureDiscountRows = function () {
        var footer = this.popupElement.querySelector('.mini-cart__footer-total');
        var total = footer === null || footer === void 0 ? void 0 : footer.querySelector('.mini-cart__total');
        if (!footer || !total)
            return;
        this.coinDiscountRow = footer.querySelector('.mini-cart__discount-row--coins');
        if (!this.coinDiscountRow) {
            this.coinDiscountRow = document.createElement('p');
            this.coinDiscountRow.className =
                'mini-cart__discount-row mini-cart__discount-row--coins';
            this.coinDiscountRow.hidden = true;
            this.coinDiscountRow.innerHTML = "\n        <span class=\"mini-cart__discount-label\">\n          <img class=\"mini-cart__discount-coin-icon\" alt=\"\" />\n          <span>ELF Coins</span>\n        </span>\n        <strong class=\"mini-cart__discount-value\">\u22120,00 \u20AC</strong>\n      ";
            footer.insertBefore(this.coinDiscountRow, total);
        }
        this.couponDiscountRow = footer.querySelector('.mini-cart__discount-row--coupon');
        if (!this.couponDiscountRow) {
            this.couponDiscountRow = document.createElement('p');
            this.couponDiscountRow.className =
                'mini-cart__discount-row mini-cart__discount-row--coupon';
            this.couponDiscountRow.hidden = true;
            this.couponDiscountRow.innerHTML = "\n        <span class=\"mini-cart__discount-label\">Coupon</span>\n        <strong class=\"mini-cart__discount-value\">\u22120,00 \u20AC</strong>\n      ";
            footer.insertBefore(this.couponDiscountRow, total);
        }
    };
    MiniCart.prototype.closeRewardTooltips = function () {
        var _a, _b;
        [this.coinTooltip, this.couponTooltip].forEach(function (tooltip) {
            tooltip === null || tooltip === void 0 ? void 0 : tooltip.classList.remove('is-open');
            tooltip === null || tooltip === void 0 ? void 0 : tooltip.setAttribute('aria-hidden', 'true');
        });
        (_b = (_a = this.coinContainer) === null || _a === void 0 ? void 0 : _a.querySelector('.mini-cart__coin-info')) === null || _b === void 0 ? void 0 : _b.setAttribute('aria-expanded', 'false');
    };
    MiniCart.prototype.toggleRewardTooltip = function (tooltip) {
        var _a, _b;
        if (!tooltip)
            return;
        var shouldOpen = !tooltip.classList.contains('is-open');
        this.closeRewardTooltips();
        if (!shouldOpen)
            return;
        tooltip.classList.add('is-open');
        tooltip.setAttribute('aria-hidden', 'false');
        if (tooltip === this.coinTooltip && ((_a = this.coinContainer) === null || _a === void 0 ? void 0 : _a.classList.contains('active'))) {
            (_b = this.coinContainer
                .querySelector('.mini-cart__coin-info')) === null || _b === void 0 ? void 0 : _b.setAttribute('aria-expanded', 'true');
        }
    };
    MiniCart.prototype.formatEuro = function (value) {
        return "".concat(new Intl.NumberFormat('de-DE', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        }).format(Math.max(0, value)), " \u20AC");
    };
    MiniCart.prototype.getCoinDiscount = function () {
        var _a, _b, _c, _d;
        var used = Number((_b = (_a = this.coinContainer) === null || _a === void 0 ? void 0 : _a.dataset.coinUsed) !== null && _b !== void 0 ? _b : 0);
        var rate = Number((_d = (_c = this.coinContainer) === null || _c === void 0 ? void 0 : _c.dataset.coinRate) !== null && _d !== void 0 ? _d : 0.01);
        return this.formatEuro(used * rate);
    };
    MiniCart.prototype.syncRewardUi = function (closeTooltips) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
        if (closeTooltips === void 0) { closeTooltips = false; }
        if (closeTooltips)
            this.closeRewardTooltips();
        var appliedCoupons = Array.from(this.couponBlock.querySelectorAll('.mini-cart__coupon-applied'));
        var hasCoupon = appliedCoupons.length > 0;
        var coinActive = !!((_a = this.coinContainer) === null || _a === void 0 ? void 0 : _a.classList.contains('active'));
        // Both discounts are rejected by the backend. If stale markup ever
        // contains both, never present an impossible combined UI state.
        if (hasCoupon && coinActive) {
            (_b = this.coinContainer) === null || _b === void 0 ? void 0 : _b.classList.remove('active');
            if (this.coinHandler)
                this.coinHandler.checked = false;
            coinActive = false;
        }
        this.couponBlock.classList.toggle('has-coupon', hasCoupon);
        this.couponBlock.classList.toggle('is-blocked', coinActive);
        (_c = this.coinContainer) === null || _c === void 0 ? void 0 : _c.classList.toggle('is-blocked', hasCoupon);
        var unavailable = ((_d = this.coinContainer) === null || _d === void 0 ? void 0 : _d.dataset.coinUnavailable) === '1';
        if (this.coinHandler) {
            this.coinHandler.disabled = unavailable || hasCoupon || this.coinRequestPending;
        }
        var couponOpener = this.couponBlock.querySelector('.mini-cart__coupon-opener');
        couponOpener === null || couponOpener === void 0 ? void 0 : couponOpener.setAttribute('aria-label', coinActive ? 'Warum kein Coupon eingelöst werden kann' : 'Coupon einlösen');
        var activeCouponCode = (_f = (_e = appliedCoupons[0]) === null || _e === void 0 ? void 0 : _e.dataset.couponCode) !== null && _f !== void 0 ? _f : '';
        if (this.coinContainer)
            this.coinContainer.dataset.activeCouponCode = activeCouponCode;
        var blockedCouponCode = (_g = this.coinContainer) === null || _g === void 0 ? void 0 : _g.querySelector('.mini-cart__blocked-coupon-code');
        if (blockedCouponCode)
            blockedCouponCode.textContent = activeCouponCode;
        var coinDiscount = this.getCoinDiscount();
        var blockedCoinDiscount = this.couponBlock.querySelector('.mini-cart__blocked-coin-discount');
        if (blockedCoinDiscount)
            blockedCoinDiscount.textContent = coinDiscount;
        if (this.coinDiscountRow) {
            this.coinDiscountRow.hidden = !coinActive;
            var icon = this.coinDiscountRow.querySelector('.mini-cart__discount-coin-icon');
            var iconUrl = (_j = (_h = this.coinContainer) === null || _h === void 0 ? void 0 : _h.dataset.coinIcon) !== null && _j !== void 0 ? _j : '';
            if (icon) {
                icon.src = iconUrl;
                icon.hidden = !iconUrl;
            }
            var value = this.coinDiscountRow.querySelector('.mini-cart__discount-value');
            if (value)
                value.textContent = "\u2212".concat(coinDiscount);
        }
        if (this.couponDiscountRow) {
            this.couponDiscountRow.hidden = !hasCoupon;
            var codes = appliedCoupons
                .map(function (coupon) { return coupon.dataset.couponCode; })
                .filter(Boolean)
                .join(', ');
            var label = this.couponDiscountRow.querySelector('.mini-cart__discount-label');
            var value = this.couponDiscountRow.querySelector('.mini-cart__discount-value');
            if (label)
                label.textContent = codes ? "Coupon ".concat(codes) : 'Coupon';
            if (value) {
                value.textContent = "\u2212".concat((_l = (_k = appliedCoupons[0]) === null || _k === void 0 ? void 0 : _k.dataset.couponDiscount) !== null && _l !== void 0 ? _l : '0,00 €');
            }
        }
    };
    MiniCart.prototype.getCart = function () {
        return __awaiter(this, void 0, void 0, function () {
            var response, error_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, 3, 4]);
                        return [4 /*yield*/, cartApi.getCart()];
                    case 1:
                        response = _a.sent();
                        if (response.data.success && response.data.data.cart_item_count) {
                            this.updateCart(response.data.data);
                            this.updateCoupon(response.data.data.applied_coupons);
                        }
                        else {
                            this.cartListElement.classList.add('empty');
                        }
                        return [3 /*break*/, 4];
                    case 2:
                        error_2 = _a.sent();
                        console.log(error_2);
                        return [3 /*break*/, 4];
                    case 3:
                        this.cartListElement.classList.remove('suspend');
                        return [7 /*endfinally*/];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    MiniCart.prototype.applyCoupon = function () {
        return __awaiter(this, void 0, void 0, function () {
            var submitButton, formData, response, data, error_3;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        submitButton = this.couponForm.querySelector('.mini-cart__coupon-submit');
                        formData = new FormData(this.couponForm);
                        submitButton.classList.add('loading');
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, 4, 5]);
                        return [4 /*yield*/, cartApi.applyCoupon(formData)];
                    case 2:
                        response = _a.sent();
                        if (response.data.success) {
                            data = response.data.data;
                            this.updateCart(data);
                            this.updateCoupon(data.applied_coupons);
                            broadcastCheckoutCartChange('coupon-applied');
                        }
                        else {
                            this.updateNotices({
                                error: [{ notice: response.data.data }],
                            });
                        }
                        return [3 /*break*/, 5];
                    case 3:
                        error_3 = _a.sent();
                        console.log(error_3);
                        return [3 /*break*/, 5];
                    case 4:
                        submitButton.classList.remove('loading');
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    MiniCart.prototype.removeCoupon = function (code) {
        return __awaiter(this, void 0, void 0, function () {
            var response_1, error_4;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, cartApi.removeCoupon(code)];
                    case 1:
                        response_1 = _a.sent();
                        if (response_1.data.success) {
                            if (response_1.data.data.cart_item_count < Number(this.counterElement.textContent)) {
                                this.cartItems.forEach(function (item) {
                                    if (!response_1.data.data.cart_items.some(function (cartItem) { return cartItem.cart_item_key === item.itemKey; })) {
                                        item.element.remove();
                                        _this.cartItems.delete(item.itemKey);
                                    }
                                });
                            }
                            this.updateCartTotal({
                                total: response_1.data.data.cart_total,
                                count: response_1.data.data.cart_item_count,
                                subtotal: response_1.data.data.cart_subtotal,
                                merchandiseTotal: response_1.data.data.cart_merchandise_total,
                            });
                            this.updateNotices(response_1.data.data.cart_notices);
                            this.updateCoupon(response_1.data.data.applied_coupons);
                            this.updateCoin(response_1.data.data.coin);
                            broadcastCheckoutCartChange('coupon-removed');
                        }
                        else {
                            console.error('Failed to remove coupon:', response_1.data.data);
                        }
                        return [3 /*break*/, 3];
                    case 2:
                        error_4 = _a.sent();
                        console.error('Error removing coupon:', error_4);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    MiniCart.prototype.updateCart = function (data) {
        this.updateCartItems(data.cart_items);
        this.cartListElement.classList.toggle('empty', data.cart_item_count < 1);
        this.updateCrossSells(data.cross_sells);
        this.updateNotices(data.cart_notices);
        this.updateCartTotal({
            total: data.cart_total,
            count: data.cart_item_count,
            subtotal: data.cart_subtotal,
            merchandiseTotal: data.cart_merchandise_total,
        });
        this.updateCoin(data.coin);
    };
    /**
     * Reconcile the controls from the server response after every cart write.
     * The backend owns reservation state; keeping the old checkbox state after
     * a failed or replaced reservation would show a discount that checkout does
     * not actually have.
     */
    MiniCart.prototype.updateCoin = function (data) {
        var _a, _b, _c;
        if (!this.coinContainer || !data)
            return;
        var points = Math.max(0, Number((_a = data.points) !== null && _a !== void 0 ? _a : 0));
        var used = Math.max(0, Number((_b = data.used) !== null && _b !== void 0 ? _b : 0));
        var rate = Math.max(0.01, Number((_c = data.direct_reward_point_rate) !== null && _c !== void 0 ? _c : 0.01));
        var enabled = data.enabled !== false;
        var unavailable = !enabled || points <= 0;
        var active = enabled && used > 0 && !data.coupon_conflict;
        var currencyName = data.currency_name || this.coinContainer.dataset.coinName || 'ELF Coins';
        var iconUrl = data.symbol || this.coinContainer.dataset.coinIcon || '';
        this.coinContainer.dataset.coinUsed = used.toString();
        this.coinContainer.dataset.coinRate = rate.toString();
        this.coinContainer.dataset.coinIcon = iconUrl;
        this.coinContainer.dataset.coinName = currencyName;
        this.coinContainer.dataset.coinUnavailable = unavailable ? '1' : '0';
        this.coinContainer.classList.toggle('active', active);
        this.coinContainer.classList.toggle('is-unavailable', unavailable);
        if (this.coinHandler) {
            this.coinHandler.checked = active;
            this.coinHandler.disabled =
                unavailable || !!data.coupon_conflict || this.coinRequestPending;
        }
        var balance = this.coinContainer.querySelector('.mini-cart__coin-balanse');
        if (balance) {
            var fragment = document.createDocumentFragment();
            fragment.appendChild(document.createTextNode("Du hast ".concat(points, " ")));
            if (iconUrl) {
                var image = document.createElement('img');
                image.className = 'mini-cart__coin-icon';
                image.src = iconUrl;
                image.alt = currencyName;
                fragment.appendChild(image);
            }
            fragment.appendChild(document.createTextNode(" ".concat(currencyName)));
            balance.replaceChildren(fragment);
        }
        this.syncRewardUi(true);
    };
    MiniCart.prototype.updateCrossSells = function (data) {
        var _this = this;
        this.crossSellsContainer.innerHTML = '';
        var crossSellsParent = this.crossSellsContainer.parentElement;
        crossSellsParent.classList.toggle('hidden', data.length < 1);
        if (data.length < 1)
            return;
        crossSellsParent.classList.toggle('hide-button', data.length < 2);
        var fragment = document.createDocumentFragment();
        data.forEach(function (item) {
            var newCartItem = _this.createCrossSellItem(item);
            fragment.appendChild(newCartItem);
        });
        this.crossSellsContainer.appendChild(fragment);
    };
    MiniCart.prototype.updateCoupon = function (data) {
        var _this = this;
        var _a, _b;
        var hasCoupon = ((_a = data === null || data === void 0 ? void 0 : data.length) !== null && _a !== void 0 ? _a : 0) > 0;
        this.couponBlock.classList.toggle('has-coupon', hasCoupon);
        (_b = this.couponBlock
            .querySelectorAll('.mini-cart__coupon-applied')) === null || _b === void 0 ? void 0 : _b.forEach(function (coupon) { return coupon.remove(); });
        if (!hasCoupon) {
            this.couponBlock.classList.remove('open');
            this.syncRewardUi(true);
            return;
        }
        var fragment = document.createDocumentFragment();
        data === null || data === void 0 ? void 0 : data.forEach(function (item) {
            var _a;
            var couponElement = document.createElement('div');
            couponElement.className = 'mini-cart__coupon-applied';
            couponElement.dataset.couponCode = item.code;
            couponElement.dataset.couponDiscount = (_a = item.discount_amount) !== null && _a !== void 0 ? _a : item.amount;
            var code = document.createElement('span');
            code.className = 'mini-cart__coupon-code';
            code.textContent = item.code;
            couponElement.appendChild(code);
            var status = document.createElement('span');
            status.className = 'mini-cart__coupon-status';
            status.textContent = 'Coupon aktiv';
            couponElement.appendChild(status);
            var removeButton = document.createElement('button');
            removeButton.className = 'mini-cart__coupon-applied-remove';
            removeButton.type = 'button';
            removeButton.dataset.couponCode = item.code;
            removeButton.setAttribute('aria-label', "Coupon ".concat(item.code, " entfernen"));
            removeButton.innerHTML = "\n        <svg width=\"16\" height=\"16\" role=\"presentation\" focusable=\"false\" aria-hidden=\"true\">\n          <use href=\"#ui/plus\"></use>\n        </svg>\n      ";
            removeButton.addEventListener('click', function (event) {
                event.preventDefault();
                _this.removeCoupon(item.code);
                removeButton.classList.add('loading');
            });
            couponElement.appendChild(removeButton);
            fragment.appendChild(couponElement);
        });
        this.couponBlock.appendChild(fragment);
        this.couponBlock.classList.remove('open');
        this.syncRewardUi(true);
    };
    MiniCart.prototype.updateCartTotal = function (_a) {
        var _b;
        var _total = _a.total, count = _a.count, subtotal = _a.subtotal, merchandiseTotal = _a.merchandiseTotal, cartMerchandiseTotal = _a.cart_merchandise_total;
        // Shipping is rendered on its own row. Coupons and ELF Coins reduce only
        // this merchandise subtotal, never the displayed shipping amount.
        var thresholdSubtotal = (_b = merchandiseTotal !== null && merchandiseTotal !== void 0 ? merchandiseTotal : cartMerchandiseTotal) !== null && _b !== void 0 ? _b : subtotal;
        this.totalPriceElement.textContent = "".concat(thresholdSubtotal, " \u20AC");
        this.counterElement.textContent = count.toString();
        this.counterElement.classList.toggle('empty', count == 0);
        this.popupElement.classList.remove('empty');
        if (this.progressBar) {
            // Use the same post-discount merchandise value that WooCommerce uses for
            // free-shipping eligibility. The pre-discount subtotal made the progress
            // message claim shipping was free after Coins had moved the cart below
            // the configured threshold.
            var numberSubtotal = parseFloat(String(thresholdSubtotal).replace(',', '.'));
            this.popupElement.classList.remove('to-min-amount', 'to-free-shipping', 'to-free-gift', 'gift-unlocked', 'done');
            var giftEnabled = !!(this.progressBar.giftBar && this.progressBar.giftAmount);
            var minAmount = this.progressBar.minAmount;
            var freeAmount = this.progressBar.freeAmount;
            var giftAmount = this.progressBar.giftAmount;
            // Default: Free shipping, no gift or already reached
            var stageClass = 'done';
            var label = 'Die Lieferung ist kostenlos!';
            var remaining = '';
            // 1. subtotal < minAmount
            if (numberSubtotal < minAmount) {
                stageClass = 'to-min-amount';
                label = 'Bis zum Mindestbestellwert: ';
                remaining = "noch ".concat(priceUtils.numberToString(minAmount - numberSubtotal), " \u20AC");
                this.progressBar.minAmontBar.style.setProperty('--range-progress', "".concat(Math.max(0, Math.min(100, (numberSubtotal / minAmount) * 100)), "%"));
                this.progressBar.freeShippingBar.style.setProperty('--range-progress', '0%');
                if (this.progressBar.giftBar) {
                    this.progressBar.giftBar.style.setProperty('--range-progress', '0%');
                }
                this.checkoutButton.classList.add('disabled');
            }
            // 2. subtotal < freeAmount
            else if (numberSubtotal < freeAmount) {
                stageClass = 'to-free-shipping';
                label = 'Bis zur kostenlosen Lieferung: ';
                remaining = "noch ".concat(priceUtils.numberToString(freeAmount - numberSubtotal), " \u20AC");
                this.progressBar.minAmontBar.style.setProperty('--range-progress', '100%');
                this.progressBar.freeShippingBar.style.setProperty('--range-progress', "".concat(Math.max(0, Math.min(100, ((numberSubtotal - minAmount) / (freeAmount - minAmount)) * 100)), "%"));
                if (this.progressBar.giftBar) {
                    this.progressBar.giftBar.style.setProperty('--range-progress', '0%');
                }
                this.checkoutButton.classList.remove('disabled');
            }
            // 3. gift enabled and subtotal < giftAmount
            else if (giftEnabled && numberSubtotal < giftAmount) {
                stageClass = 'to-free-gift';
                label = 'Bis zum Gratisgeschenk: ';
                remaining = "noch ".concat(priceUtils.numberToString(giftAmount - numberSubtotal), " \u20AC");
                this.progressBar.minAmontBar.style.setProperty('--range-progress', '100%');
                this.progressBar.freeShippingBar.style.setProperty('--range-progress', '100%');
                this.progressBar.giftBar.style.setProperty('--range-progress', "".concat(Math.max(0, Math.min(100, ((numberSubtotal - freeAmount) / (giftAmount - freeAmount)) * 100)), "%"));
                this.checkoutButton.classList.remove('disabled');
            }
            // 4. gift enabled and subtotal >= giftAmount
            else if (giftEnabled && numberSubtotal >= giftAmount) {
                stageClass = 'done';
                label = 'Gratisgeschenk hinzugefügt!';
                remaining = '';
                this.progressBar.minAmontBar.style.setProperty('--range-progress', '100%');
                this.progressBar.freeShippingBar.style.setProperty('--range-progress', '100%');
                this.progressBar.giftBar.style.setProperty('--range-progress', '100%');
                this.checkoutButton.classList.remove('disabled');
            }
            // 5. >= freeAmount, no gift enabled, default "done"
            else if (numberSubtotal >= freeAmount) {
                stageClass = 'done';
                label = 'Die Lieferung ist kostenlos!';
                remaining = '';
                this.progressBar.minAmontBar.style.setProperty('--range-progress', '100%');
                this.progressBar.freeShippingBar.style.setProperty('--range-progress', '100%');
                if (this.progressBar.giftBar) {
                    this.progressBar.giftBar.style.setProperty('--range-progress', '0%');
                }
                this.checkoutButton.classList.remove('disabled');
            }
            // Set text and remaining
            this.popupElement.classList.add(stageClass);
            this.progressBar.textElement.textContent = label;
            this.progressBar.remainingElement.textContent = remaining;
        }
        else {
            this.checkoutButton.classList.remove('disabled');
        }
    };
    MiniCart.prototype.updateNotices = function (data) {
        this.noticesContainer.innerHTML = '';
        if (!data || (Array.isArray(data) && data.length === 0))
            return;
        var fragment = document.createDocumentFragment();
        var _loop_1 = function (key) {
            if (data.hasOwnProperty(key)) {
                data[key].forEach(function (item) {
                    var message = document.createElement('p');
                    message.classList.add('mini-cart__notice');
                    message.classList.add(key);
                    message.innerHTML = item.notice;
                    fragment.appendChild(message);
                });
            }
        };
        for (var key in data) {
            _loop_1(key);
        }
        this.noticesContainer.appendChild(fragment);
    };
    MiniCart.prototype.createCartItem = function (data) {
        var li = document.createElement('li');
        li.classList.add('mini-cart__item');
        li.setAttribute('data-key', data.key);
        li.setAttribute('data-product', data.product_id.toString());
        if (data.variation_id)
            li.setAttribute('data-variation', data.variation_id.toString());
        if (data.is_gift)
            li.classList.add('mini-cart__item_gift');
        var a = document.createElement('a');
        a.setAttribute('href', data.product_link);
        var img = document.createElement('img');
        img.classList.add('mini-cart__item-image');
        img.src = data.image;
        img.alt = data.product_name;
        var divInfo = document.createElement('div');
        divInfo.classList.add('mini-cart__item-info');
        var titleA = document.createElement('a');
        titleA.setAttribute('href', data.product_link);
        titleA.classList.add('mini-cart__item-title');
        titleA.textContent = data.product_name;
        if (data.bundled_items && data.bundled_items.length) {
            var description = document.createElement('p');
            description.classList.add('mini-cart__item-description');
            description.textContent = data.bundled_items.join(', ');
            divInfo.appendChild(description);
        }
        // const ingredientsP = document.createElement('p');
        // ingredientsP.classList.add('mini-cart__item-ingredients');
        // ingredientsP.textContent = data.ingredients;
        var divDetails = document.createElement('div');
        divDetails.classList.add('mini-cart__item-details');
        var priceSpan = document.createElement('span');
        priceSpan.classList.add('mini-cart__item-price');
        priceSpan.textContent = data.product_price;
        var buttonReturn = document.createElement('button');
        buttonReturn.classList.add('mini-cart__item-return');
        buttonReturn.textContent = 'Zurücklegen';
        var divQuantity = document.createElement('div');
        divQuantity.classList.add('mini-cart__item-quantity');
        var decreaseButton = document.createElement('button');
        decreaseButton.classList.add('mini-cart__item-quantity-button', 'mini-cart__item-quantity-button_decrease');
        decreaseButton.setAttribute('aria-label', "Reduce quantity of ".concat(data.product_name, "."));
        decreaseButton.textContent = '－';
        var quantityInput = document.createElement('input');
        quantityInput.classList.add('mini-cart__item-quantity-input');
        quantityInput.type = 'number';
        quantityInput.step = '1';
        quantityInput.min = '0';
        quantityInput.setAttribute('aria-label', "Quantity of ".concat(data.product_name, "."));
        quantityInput.value = data.quantity.toString();
        var increaseButton = document.createElement('button');
        increaseButton.classList.add('mini-cart__item-quantity-button', 'mini-cart__item-quantity-button_increase');
        increaseButton.setAttribute('aria-label', "Increase quantity of ".concat(data.product_name, "."));
        increaseButton.textContent = '+';
        a.appendChild(img);
        divQuantity.appendChild(decreaseButton);
        divQuantity.appendChild(quantityInput);
        divQuantity.appendChild(increaseButton);
        divDetails.appendChild(priceSpan);
        divDetails.appendChild(buttonReturn);
        divDetails.appendChild(divQuantity);
        divInfo.prepend(titleA);
        // divInfo.appendChild(ingredientsP);
        divInfo.appendChild(divDetails);
        li.appendChild(a);
        li.appendChild(divInfo);
        return li;
    };
    MiniCart.prototype.createCrossSellItem = function (data) {
        var li = document.createElement('li');
        li.classList.add('mini-cart__cross-sells-item');
        var a = document.createElement('a');
        a.setAttribute('href', data.permalink);
        a.classList.add('mini-cart__cross-sells-item__link');
        var imageWrapper = document.createElement('div');
        imageWrapper.classList.add('mini-cart__cross-sells-item__image');
        imageWrapper.innerHTML = data.image;
        var divInfo = document.createElement('div');
        divInfo.classList.add('mini-cart__cross-sells-item__info');
        var title = document.createElement('p');
        title.classList.add('mini-cart__cross-sells-item__name');
        title.textContent = data.name;
        var priceHTML = createPriceHtml({
            price: data.price,
            onSale: data.on_sale,
            regularPrice: data.regular_price,
            className: 'mini-cart__cross-sells-item__price',
        });
        var addToCartButton = createAddToCartButton({
            id: data.id,
            parentId: data.parent_id,
            inStock: data.on_stock,
            type: data.type,
        });
        divInfo.appendChild(title);
        divInfo.appendChild(priceHTML);
        a.appendChild(imageWrapper);
        a.appendChild(divInfo);
        a.appendChild(addToCartButton);
        li.appendChild(a);
        return li;
    };
    MiniCart.prototype.removeItem = function (itemKey) {
        var _this = this;
        var item = this.cartItems.get(itemKey);
        var returnButton = item.element.querySelector('.mini-cart__item-return');
        var details = item.element.querySelector('.mini-cart__item-details');
        var timerWrapper = document.createElement('div');
        timerWrapper.classList.add('mini-cart__item-timer');
        var timerHTML = document.createElement('span');
        timerHTML.textContent = '5';
        var svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
        svg.setAttribute('width', '26');
        svg.setAttribute('height', '26');
        svg.appendChild(createCircle({ size: 13, width: 1 }));
        svg.appendChild(createCircle({ size: 13, width: 1 }));
        timerWrapper.appendChild(timerHTML);
        timerWrapper.appendChild(svg);
        details.insertBefore(timerWrapper, returnButton);
        item.element.classList.add('removed');
        var timer = setInterval(function () {
            var count = Number(timerHTML.textContent) - 1;
            timerHTML.textContent = String(count);
            if (count <= 0) {
                clearInterval(timer);
                item.element.remove();
                _this.cartItems.delete(itemKey);
            }
        }, 1000);
        item.clearTimer = function () {
            clearInterval(timer);
            timerWrapper.remove();
        };
        returnButton.addEventListener('click', this.returnItem.bind(this));
    };
    MiniCart.prototype.returnItem = function (evt) {
        return __awaiter(this, void 0, void 0, function () {
            var target, currentKey, item, response, newItem, error_5;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        target = evt.target;
                        target.removeEventListener('click', this.returnItem.bind(this));
                        currentKey = target.closest('.removed').getAttribute('data-key');
                        item = this.cartItems.get(currentKey);
                        item.clearTimer();
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, 4, 5]);
                        return [4 /*yield*/, cartApi.addToCart(item)];
                    case 2:
                        response = _a.sent();
                        if (response.data.success) {
                            item.element.classList.remove('removed');
                            item.quantity.setQuantity(1);
                            newItem = response.data.data.cart_items.find(function (item) { return !_this.cartItems.has(item.cart_item_key); });
                            if (newItem) {
                                item.quantity.updateItemKey(newItem.cart_item_key);
                                this.cartItems.set(newItem.cart_item_key, {
                                    element: item.element,
                                    itemKey: newItem.cart_item_key,
                                    quantity: item.quantity,
                                });
                                this.cartItems.delete(currentKey);
                            }
                            target.removeEventListener('click', this.returnItem.bind(this));
                            this.updateCartTotal({
                                total: response.data.data.cart_total,
                                count: response.data.data.cart_item_count,
                                subtotal: response.data.data.cart_subtotal,
                                merchandiseTotal: response.data.data.cart_merchandise_total,
                            });
                            this.updateCoin(response.data.data.coin);
                            broadcastCheckoutCartChange('item-restored');
                        }
                        else {
                            console.error('Failed to add product to cart:', response.data.data);
                        }
                        return [3 /*break*/, 5];
                    case 3:
                        error_5 = _a.sent();
                        console.error('Error adding product to cart:', error_5);
                        return [3 /*break*/, 5];
                    case 4:
                        target.classList.remove('loading');
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    MiniCart.prototype.removeGift = function (items, count) {
        var _this = this;
        if (count > Number(this.counterElement.textContent))
            return;
        this.cartItems.forEach(function (item) {
            if (!items.some(function (cartItem) { return cartItem.cart_item_key === item.itemKey; }) &&
                item.element.classList.contains(SELECTORS.CART_ITEM_GIFT)) {
                item.element.remove();
                _this.cartItems.delete(item.itemKey);
            }
        });
    };
    MiniCart.prototype.updateCartItems = function (cartItems) {
        var _this = this;
        cartItems.forEach(function (item) {
            if (_this.cartItems.has(item.cart_item_key)) {
                var cartItem = _this.cartItems.get(item.cart_item_key);
                if (cartItem.quantity.getValue() != item.quantity) {
                    cartItem.quantity.setQuantity(item.quantity);
                }
            }
            else {
                var newCartItem = _this.createCartItem({
                    key: item.cart_item_key,
                    image: item.image,
                    product_name: item.product_name,
                    ingredients: item.ingredients,
                    product_price: item.product_price,
                    quantity: item.quantity,
                    product_link: item.product_link,
                    product_id: item.product_id,
                    variation_id: item.variation_id,
                    bundled_items: item.bundled_items,
                    is_gift: item.is_gift,
                });
                _this.cartItems.set(item.cart_item_key, {
                    element: newCartItem,
                    itemKey: item.cart_item_key,
                    quantity: new CartItemQuantity({
                        container: newCartItem.querySelector(SELECTORS.CART_ITEM_QUANTITY),
                        selectors: {
                            decrease: SELECTORS.CART_ITEM_QUANTITY_BUTTON_DECREASE,
                            increase: SELECTORS.CART_ITEM_QUANTITY_BUTTON_INCREASE,
                            input: SELECTORS.CART_ITEM_QUANTITY_INPUT,
                        },
                        itemKey: item.cart_item_key,
                    }),
                });
                _this.cartListElement.appendChild(newCartItem);
            }
        });
    };
    MiniCart.prototype.updateCartItemQuantity = function (data) {
        this.updateNotices(data.cart_notices);
        this.updateCoupon(data.applied_coupons);
        this.removeGift(data.cart_items, data.cart_item_count);
        this.updateCartItems(data.cart_items);
        this.updateCartTotal({
            total: data.cart_total,
            count: data.cart_item_count,
            subtotal: data.cart_subtotal,
            merchandiseTotal: data.cart_merchandise_total,
        });
        this.updateCoin(data.coin);
    };
    MiniCart.prototype.toggleCoin = function (apply) {
        return __awaiter(this, void 0, void 0, function () {
            var response, error_6;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.coinRequestPending)
                            return [2 /*return*/];
                        if (apply && this.couponBlock.classList.contains('has-coupon')) {
                            if (this.coinHandler)
                                this.coinHandler.checked = false;
                            this.toggleRewardTooltip(this.coinTooltip);
                            return [2 /*return*/];
                        }
                        this.closeRewardTooltips();
                        this.coinRequestPending = true;
                        this.coinContainer.classList.toggle('active', apply);
                        this.coinContainer.classList.add('loading');
                        this.syncRewardUi();
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, 4, 5]);
                        return [4 /*yield*/, cartApi.toggleCoin(apply)];
                    case 2:
                        response = _a.sent();
                        if (response.data.success) {
                            this.updateCartTotal({
                                total: response.data.data.cart_total,
                                count: response.data.data.cart_item_count,
                                subtotal: response.data.data.cart_subtotal,
                                merchandiseTotal: response.data.data.cart_merchandise_total,
                            });
                            this.updateCoin(response.data.data.coin);
                            if (apply) {
                                this.updateCoupon(response.data.data.applied_coupons);
                            }
                            else {
                                this.syncRewardUi(true);
                            }
                            broadcastCheckoutCartChange(apply ? 'coins-applied' : 'coins-removed');
                        }
                        else {
                            throw new Error(response.data.data);
                        }
                        return [3 /*break*/, 5];
                    case 3:
                        error_6 = _a.sent();
                        console.error(error_6);
                        this.coinContainer.classList.toggle('active', !apply);
                        if (this.coinHandler)
                            this.coinHandler.checked = !apply;
                        this.syncRewardUi(true);
                        this.updateNotices({ error: [{ notice: error_6 }] });
                        return [3 /*break*/, 5];
                    case 4:
                        this.coinRequestPending = false;
                        this.coinContainer.classList.remove('loading');
                        this.syncRewardUi();
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    return MiniCart;
}(Popup));
var miniCart = new MiniCart({
    popupElement: miniCartElement,
    closeButtonClass: 'mini-cart__close',
    cartItems: Array.from(document.querySelectorAll('.mini-cart__item')),
    cartListElement: document.querySelector('.mini-cart__list'),
    totalPriceElement: document.querySelector('.mini-cart__total-value'),
    counterElement: document.querySelector('.wp-block-vape-shop-mini-cart__count'),
    checkoutButton: document.querySelector('.mini-cart__checkout'),
    shipingElement: document.querySelector('.mini-cart__footer-shipping'),
    progressBar: progressBar,
});
button.addEventListener('click', function () {
    miniCart.open();
});
